<template>
    <div class="modal" tabindex="-1" role="dialog" style="display:inline-block;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header p-2">
                    <h6 class="modal-title">{{defaultPanelName}}</h6>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="close">
                    <span aria-hidden="true"><cancel-icon class="close-icon mt-1" style="height: 30px !important;
                width: 30px !important;
                color: #fff;"></cancel-icon></span>
                    </button>
                </div>
                <div class="modal-body"> 
                    <div>{{confirmMessage}}</div>
                </div>
                <div class="modal-footer p-0 primary-btn-style">
                    <button class="btn btn-outline-secondary mr-2" data-dismiss="modal" @click="secondaryButtonAction()">{{secondaryButtonName}}</button>
                    <button class="btn btn-outline-primary mr-2" @click='primaryButtonAction()'>{{primaryButtonName}}</button>
                </div>
            </div>
        </div>  
        
    </div>              
</template>

<script>
    import CancelIcon from "../core/InlineCancelField.vue";

    export default {
        props:["secondaryButtonName","primaryButtonName","confirmMessage","confirmPanelTitle"],
        data() {
            return{
                checkboxConfirmText :'',
                defaultPanelName:"",
            }    
        },
        components:{
            'cancel-icon':CancelIcon
        },
        methods:{
            secondaryButtonAction(){
                this.$emit("secondaryButtonAction")
            },
            primaryButtonAction(){
                this.$emit("primaryButtonAction")
            },
            close(){
                this.$emit('close');
            },
        },

        created(){
            this.defaultPanelName = this.$t("Confirm panel"); 
            //overide the default name
            if(this.confirmPanelTitle){
                this.defaultPanelName = this.confirmPanelTitle;
            }
        },
    }
</script>


<style lang="scss" scoped>
    $header-background: #1a1a1a; //header bar background color (eg. Top nav)
    // $border-color: 1px solid #1a1a1a;
    $secondary-border-color: 1px solid #3a3a3a;
    $searchBar-border-color: 1px solid #202020;
    $background: #121212; //background color
    $background-color-on-hover: #141414;
    $body-background-color: #0d0d0d !important;; //Application background color
    $text-color: #eee;
    $dull-text-color: #757575;
    // $secondary-text-color: #bbb;
    $table-row-border: none;
    $active-blue : #007bff;
    $modal-border:1px solid #202020;
    $modal-background: #0a0a0a;
    $header-color:#9e9e9e; //Color of the header's title or nav bar labels

    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $secondary-text-color: #9c9c9c;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #4a4a4a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $icon-hover:#2c3339;
    $input-field-border-color:1px solid #3a3a3a;

    .modal-dialog {
        max-width: 450px !important;
        width: 450px !important;
        height: fit-content !important;
        margin: 0;
        padding: 0;
    }
  
    .modal-content {
        height: auto !important;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            background: $primary-background;
            height: fit-content;
            overflow: auto;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: block;
        position: fixed;
        inset-inline-start: 0px;
        top: 20%;
    }
    .modal:before {
        content: "";
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }

    .btn{
        font-size:14px !important;
        height:100%;
    }


    .border{
        border: $border-color !important;
    }

    .activeclass{
        color: $active-blue;
    }

    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height:58px;
        .modal-title{
        color:$text-color;
        padding: 2%;
        }
    }

    .modal-header .close {
        margin: 0px !important;
    }
    button.close {
        padding: 0;
        background-color: transparent;
        border: 0;
    }

    ul{
        list-style-type: none;
    }

    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }

    .comm-input-field-style{
        background: $primary-background!important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: $input-field-height;
    }
    .comm-input-label{
        display:inline-block;
        width:100%;
        margin:20px 10px;
        width:80%;
    }

    .primary-btn-style{
        margin-top:1%;
        justify-content: flex-end;
        button{
            height: 35px;
            width: 70px;
        font-size:14px;
        }
    }

    .secondary-btn-style{
        color:$text-color;
    }
    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }
</style>